import React, { ReactElement, useEffect } from 'react';
import { getUiamUrlParams } from '../helpers/uiam-helpers';
import setCookie from '../helpers/set-cookie';
import CONSTANT from '../constants/common';
import { getUIAMLoginUrl, sdAccountSummary } from '../config';
import LoadingOverlayComponent from '../components/LoadingOverlay';
import { isSecureRedirectUrl } from '../helpers/common';

function openTargetUrlAsync(url: string): void {
  setTimeout(() => {
    window.open(url, '_self');
  }, 300);
}

export const UiamLandingRedirection = (): ReactElement => {
  const handleRedirection = () => {
    const pathName = window.location.search;
    const tokens = getUiamUrlParams(pathName);
    if (tokens?.accessToken && tokens?.targetUrl) {
      setCookie(
        CONSTANT.UIAM_ACCESS_TOKEN,
        tokens?.accessToken,
        parseInt(process.env.GATSBY_UIAM_TOKEN_EXPIRY)
      );
      // Security: Validate targetUrl protocol and domain before redirect
      const allowedDomains = ['singtel.com', 'shop.singtel.com'];
      if (isSecureRedirectUrl(tokens?.targetUrl, allowedDomains)) {
        openTargetUrlAsync(tokens?.targetUrl);
      } else {
        openTargetUrlAsync(getUIAMLoginUrl(sdAccountSummary, true));
      }
    } else {
      openTargetUrlAsync(getUIAMLoginUrl(sdAccountSummary, true));
    }
  };

  useEffect(() => {
    handleRedirection();
  }, []);

  return <LoadingOverlayComponent />;
};

export default UiamLandingRedirection;
